import { createFileRoute, redirect } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";

export const Route = createFileRoute("/app/$customer/requests/")({
  errorComponent: ({ error }) => <RouteError error={error} />,
  beforeLoad: ({ params, search }) => {
    throw redirect({
      to: "/app/c/$customerSlug/requests",
      params: { customerSlug: params.customer },
      search: () => search,
      replace: true,
    });
  },
});
